import { Component, OnInit, Input, Injectable } from '@angular/core';
import { Router, Resolve } from '@angular/router';
import { BranchService } from '../../../shared/_services/branch.service';
import { Branch, MissingData } from '../../../shared/models/missingdata.model';
import { FileService } from '../../../shared/_services/file.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-fill-branch',
  templateUrl: './fill-branch.component.html',
  styleUrls: ['./fill-branch.component.css']
})
export class FillBranchComponent implements OnInit {

  branchList: Branch[];
  btnText: string;


  constructor(
    private branchService: BranchService,
    private fileService: FileService,
    private router: Router) { }

  ngOnInit() {

    this.fileService.getMissingData()
      .subscribe((res: MissingData) => {
        this.branchList = res.listMissingBranches as Branch[];
        if (this.branchList === null || this.branchList.length < 1) {
          this.router.navigate(['/manage-file/fill-cities']);
        } else {
          this.btnText = this.fileService.checkStep(0,res) ? 'Siguiente' : 'Finalizar'
        }
      }, error => {
        console.log(error)
        this.router.navigate(['/']);
      });
  }

  onSubmit() {
    this.branchService.saveBranches(this.branchList)
      .subscribe((res: any) => { console.log(res) }, err => console.log(err));
    //console.log(this.branchList);
    this.router.navigate(['/manage-file/fill-cities']);
  }

}
